export default __webpack_public_path__ + "174bf52079eee336ab0057e7d973507d.svg";